import { useCurrentUser } from 'src/hooks/user';

import { useVerifierStaff } from './useVerifierStaff';

export const useCurrentUserVerifierStaff = () => {
  const { user } = useCurrentUser();

  return useVerifierStaff(user?.verifierStaff?.id);
};
